import { S_STORE, webStorage } from "../utils/webStorage";
import getSiteInfo from "../utils/getSiteInfo";
import api from "../utils/api";

export const getStoreInfo = () => {
  return webStorage.get(S_STORE);
};
export const getStores = async () => {
  const siteInfo = await getSiteInfo();
  const { obj } = await api.store.list({
    orgId: siteInfo.organization
  });
  return obj || [];
};
